export const USER_CREATE = 'API|USER/CREATE'
export const USER_CREATE_FULFILLED = `FULFILLED_${USER_CREATE}`
export const USER_CREATE_PENDING = `PENDING_${USER_CREATE}`
export const USER_CREATE_REJECTED = `REJECTED_${USER_CREATE}`

export const USERS_GET = 'API|USERS/GET'
export const USERS_GET_FULFILLED = `FULFILLED_${USERS_GET}`
export const USERS_GET_PENDING = `PENDING_${USERS_GET}`
export const USERS_GET_REJECTED = `REJECTED_${USERS_GET}`

export const USERS_SORT_BY_SET = 'USERS/SORT/BY/SET'
export const USERS_SORT_ORDER_SET = 'USERS/SORT/ORDER/SET'
